/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WeatherMoonIcon20Solid = forwardRef('WeatherMoonIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M8.447 3.818c.145-.383.04-.78-.196-1.041a.982.982 0 0 0-1.081-.262A8 8 0 1 0 17.485 12.83a.982.982 0 0 0-.262-1.081 1.015 1.015 0 0 0-1.04-.197 6 6 0 0 1-7.735-7.735Z" })));
});
